import { FloatingTooltip } from '../../../Floating'
import { Switch } from '../../../Switch'
import { TableCellBase } from '../TableCellBase'

import * as styles from './TableSwitchCell.module.css'

function TableSwitchCell({
  disabled,
  hasError,
  label,
  labelProps,
  qaName,
  switchClassName = styles.switch,
  tooltip,
  value,
  onChange,
  ...cellProps
}) {
  return (
    <TableCellBase {...cellProps}>
      <FloatingTooltip content={tooltip}>
        <div className={styles.container}>
          <Switch
            className={switchClassName}
            disabled={disabled}
            hasError={hasError}
            label={label}
            labelProps={labelProps}
            qaName={qaName}
            value={value}
            onChange={onChange}
          />
        </div>
      </FloatingTooltip>
    </TableCellBase>
  )
}

export default TableSwitchCell
